class ValueTrackerObjGen {
    constructor(wrapCtx, evtCtx, valueTracker) {
        this._data = wrapCtx.getWrapper({});
        this._events = evtCtx.getEvents(this._data);
        this._valueTracker = valueTracker;
    }

    get data() {
        return this._data;
    }

    get events() {
        return this._events;
    }

    update() {
        this._valueTracker.updateIfNeeded(({ prop: { newExists, newValue } }) => {
            if (newExists) {
                this._data.value = newValue;
            } else {
                delete this._data.value;
            }
        });
    }
}

export default ValueTrackerObjGen;
